import templateUrl from 'emun.blog/blog-list.htm'
import BlogPrompt from 'emun.blog/blog-prompt'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import $session from 'servicestack/session'
import resolve from 'ioc/resolve'

class BlogListController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
        let $rootScope = resolve('$rootScope');
		$rootScope.$on('$blogSubmitted', () => $ctrl.query.load(true));
    }
    $onInit(){
        const $ctrl = this;

        $ctrl.query = new AutoQuery({
            url: 'QueryFormSubmissions.json?Label=blog',
            tagTotalsUrl: 'QueryFormSubmissionTagTotals.json?Label=blog',
            hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
			orderBy: '-CreatedOn,Id',
            sortOptions:{
				'CreatedOn,Id': 'Created: Newest',
				'-CreatedOn,Id': 'Created: Oldest'
            },
            filters: [
                {tag: 'Category', title: 'Category'},
            ],
            autoLoad: true,
            pageSize: 12
        });
    }
    load(){
        const $ctrl = this;
        $ctrl.query.load(true);
    }
    create(){
        const $ctrl = this;
		BlogPrompt.open({}).then(() => $ctrl.load());
    }
    view(blog){
        const $ctrl = this;
        BlogPrompt.open({blog: blog}).then(() => $ctrl.load());
    }
}

export default BlogListController;